import { differenceInDays, startOfDay } from 'date-fns';

/**
 * Formats a date to show relative day names in Dutch
 * @param dateStart - The start date/time of the program
 * @returns Formatted day string: "vandaag", "gisteren", "eergisteren", "morgen", "overmorgen", or day name
 */
export const formatDay = (dateStart: Date | string): string => {
    const date = typeof dateStart === 'string' ? new Date(dateStart) : dateStart;
    const today = startOfDay(new Date());
    const programDay = startOfDay(date);
    const dayDiff = differenceInDays(today, programDay);

    switch (dayDiff) {
        case 2:
            return 'Eergisteren';
        case 1:
            return 'Gisteren';
        case 0:
            return 'Vandaag';
        case -1:
            return 'Morgen';
        case -2:
            return 'Overmorgen';
        default: {
            // Return day name in Dutch
            const formatter = new Intl.DateTimeFormat('nl-NL', { weekday: 'long' });
            const dayName = formatter.format(date);
            return dayName.charAt(0).toUpperCase() + dayName.slice(1);
        }
    }
};
